/*!
VueLayers
Vue 2 components to work with OpenLayers

@package vuelayers
@author Vladimir Vershinin <ghettovoice@gmail.com>
@version 0.7.5
@license MIT
@copyright (c) 2017, Vladimir Vershinin <ghettovoice@gmail.com>
*/
'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var StyleBox = _interopDefault(require('../style-box'));
var core = require('../core');

/**
 * @deprecated
 * @todo remove in the next release
 */
var Style = {
  name: 'vl-style-container',
  extends: StyleBox.Style,
  beforeCreate: function beforeCreate() {
    core.debug.warndbg('vl-style-container was renamed to vl-style-box. ' + 'Name "vl-style-container" now is deprecated and will be removed in the next release.');
  }
};

var index = {
  Style: Style,
  install: function install(Vue) {
    Vue.component(Style.name, Style);
  }
};

module.exports = index;

//# sourceMappingURL=index.js.map



//////////////////
// WEBPACK FOOTER
// ./~/vuelayers/lib/style-container/index.js
// module id = 1198
// module chunks = 1